import HipsterSizeChart from './HipsterSizeChart'

export default HipsterSizeChart
